import Helper from "@ember/component/helper";
import { service } from "@ember/service";
import type Patient from "parog-web/models/patient";

type Positional = Array<string>;
type Named = { patient?: Patient };
type Return = () => void;

export interface TransitionToSignature {
  Args: {
    Positional: Positional;
    Named: Named;
  };
  Return: Return;
}

export default class extends Helper<TransitionToSignature> {
  @service router;

  override compute([route]: Positional): Return {
    return () => {
      this.router.transitionTo(route);
    };
  }
}
